import {RerenderApp} from './render'
import state from "./State/State";

RerenderApp(state)
